import { render, staticRenderFns } from "./blogcategorydetails.vue?vue&type=template&id=01439c38&scoped=true"
import script from "./blogcategorydetails.vue?vue&type=script&lang=js"
export * from "./blogcategorydetails.vue?vue&type=script&lang=js"
import style0 from "./blogcategorydetails.vue?vue&type=style&index=0&id=01439c38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01439c38",
  null
  
)

export default component.exports